module.exports = __webpack_public_path__ + "img/JW.b2b468fe.jpg";